@if (!readonly) {
    <mat-form-field class="flex" [ngClass]="{ 'cb-soft-required': softRequired && !required }">
        <mat-label>{{ label }}</mat-label>
        <mat-select
            [cbRequireSelectionValidator]="required"
            [required]="required"
            [disabled]="disabled"
            [ignoreDirty]="ignoreDirty"
            [name]="internalName"
            [(ngModel)]="value"
        >
            @for (opt of boolOptions; track opt) {
                <mat-option [value]="opt.id">
                    {{ opt.label }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
}
@if (readonly) {
    <div class="flex">
        <cb-display-value-new class="flex" [label]="label">
            {{ value?.label }}
        </cb-display-value-new>
    </div>
}
